import { useLayoutEffect, useState } from "react";

// Measures the real vertical gap between the bottom of `aboveRef` and the
// top of `belowRef`, live via ResizeObserver. Game boards used to size
// themselves off calc(100dvh - <guessed reserve>px), which overestimates
// available space because 100dvh doesn't know about ancestor chrome
// (navbar, page padding, status bars). This measures the actual rendered
// gap instead of guessing it. aboveRef/belowRef must be siblings that do
// NOT contain the element being sized, or the measurement is circular.
export default function useMeasuredAvailableHeight(aboveRef, belowRef) {
  const [height, setHeight] = useState(null);

  useLayoutEffect(() => {
    const aboveEl = aboveRef.current;
    const belowEl = belowRef.current;
    if (!aboveEl || !belowEl) return;

    const measure = () => {
      const aboveBottom = aboveEl.getBoundingClientRect().bottom;
      const belowTop = belowEl.getBoundingClientRect().top;
      setHeight(Math.max(0, belowTop - aboveBottom));
    };

    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(aboveEl);
    observer.observe(belowEl);
    window.addEventListener("resize", measure);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [aboveRef, belowRef]);

  return height;
}
